import { useRouter } from 'next/router';

const routeChecker = (route) => {
	const router = useRouter();
	const is_route = router.pathname == route;
	return is_route;
};

export default routeChecker;
